module.exports = __webpack_public_path__ + "static/media/7.8d44c267.jpg";